import { MatchDetailsOdds } from "@/interfaces/liveGamesType";
import { api } from "@/services/api";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const fetchLiveOddsByMatch = (
  matchId: number | string,
  options?: Partial<UseQueryOptions<MatchDetailsOdds>>
) => {
  const response = useQuery({
    queryKey: ["football/getLiveOddsByMatch", matchId],
    queryFn: async () => {
      const res = await api.get("/football/getLiveOddsByMatch", {
        params: {
          matchId: matchId,
        },
      });
      return res.data[matchId];
    },
    ...options,
  });

  return response;
}; 